import { gql } from 'react-apollo';

export default gql`
  mutation createRepublicInvestorUser(
    $input: CreateRepublicInvestorUserInput!
  ) {
    createRepublicInvestorUser(input: $input) {
      _id
      firstName
      lastName
      email
      offerId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/createRepublicInvestorUser.js